import React, { useState } from "react";
import { Row, Col, Tabs, Tab, Form } from "react-bootstrap";
import Title from "../common/Title";
import { TbChartBar } from "react-icons/tb";
import RunbookExecutionsTab from "./RunbookExecutionsTab";
import ApiPerformanceTab from "./ApiPerformanceTab";
import TrendsTab from "./TrendsTab";

function Analytics(props) {
  const [dateRange, setDateRange] = useState("oneMonth");
  const [activeTab, setActiveTab] = useState("runbooks");

  return (
    <div>
      {!props.hideTitle && <Title text="Runbook Analytics" icon={<TbChartBar className="mb-1" />} />}

      <Row className="mb-3">
        <Col md={4}>
          <Form.Group>
            <Form.Label>Date Range</Form.Label>
            <Form.Select
              value={dateRange}
              onChange={(e) => setDateRange(e.target.value)}
            >
              <option value="24hours">Last 24 Hours</option>
              <option value="lastWeek">Last Week</option>
              <option value="thisMonth">This Month</option>
              <option value="lastMonth">Last Month</option>
              <option value="oneMonth">Last 30 Days</option>
              <option value="3months">Last 3 Months</option>
              <option value="6months">Last 6 Months</option>
              <option value="ytd">Year to Date</option>
              <option value="1year">Last Year</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Tabs
        id="analytics-tabs"
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-3"
        mountOnEnter
      >
        <Tab eventKey="runbooks" title="Runbook Executions">
          <RunbookExecutionsTab user={props.user} dateRange={dateRange} />
        </Tab>
        <Tab eventKey="api" title="API Performance">
          <ApiPerformanceTab user={props.user} dateRange={dateRange} />
        </Tab>
        <Tab eventKey="trends" title="Trends Over Time">
          <TrendsTab user={props.user} dateRange={dateRange} />
        </Tab>
      </Tabs>
    </div>
  );
}

export default Analytics;
